import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType } from 'vue';
import { Icons, IconType } from '@/shared/icons/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
  icon: {
    type: String as PropType<IconType>,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const iconComponent = computed(() => Icons[props.icon]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(iconComponent.value)))
}
}

})